
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

/**
 * Composant : Modal + Formulaire d'invitation utilisateur
 */
const ChangePasswordModal = ({ isOpen, toggle,  onSubmit }) => {
  const validation = useFormik({
    initialValues: {
    
      current_password: "",
      new_password: "",
      new_password_confirmation: ""
    
    },
    validationSchema: Yup.object({
      current_password: Yup.string()
        .required("Veuillez saisir votre mot de passe actuel"),
      new_password: Yup.string()
        .min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères")
        .required("Veuillez saisir le nouveau mot de passe"),
      new_password_confirmation: Yup.string()
        .oneOf([Yup.ref("new_password"), null], "Les mots de passe ne correspondent pas")
        .required("Veuillez confirmer le nouveau mot de passe"),
    }),
    onSubmit: (values) => {
      onSubmit(values);
      validation.resetForm();
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} tag="h4">
        Modifier mot de passe
      </ModalHeader>

      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <Row>
            <Col xs="12">
              <div className="mb-3">
                <Label>Mot de passe actuel</Label>
                <Input
                  name="current_password"
                  type="password"
                  placeholder="Mot de passe actuel"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.current_password}
                  invalid={
                    validation.touched.current_password && validation.errors.current_password
                      ? true
                      : false
                  }
                />
                <FormFeedback>{validation.errors.current_password}</FormFeedback>
              </div>

              <div className="mb-3">
                <Label>Nouveau mot de passe</Label>
                <Input
                  name="new_password"
                  type="password"
                  placeholder="Nouveau mot de passe"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.new_password}
                  invalid={
                    validation.touched.new_password && validation.errors.new_password
                      ? true
                      : false
                  }
                />
                <FormFeedback>{validation.errors.new_password}</FormFeedback>
              </div>

              <div className="mb-3">
                <Label>Confirmation du mot de passe</Label>
                <Input
                  name="new_password_confirmation"
                  type="password"
                  placeholder="Confirmation du mot de passe"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.new_password_confirmation}
                  invalid={
                    validation.touched.new_password_confirmation && validation.errors.new_password_confirmation
                      ? true
                      : false
                  }
                />
                <FormFeedback>{validation.errors.new_password_confirmation}</FormFeedback>
              </div>

             

              

              
            </Col>
          </Row>

          <div className="text-end">
            <Button color="primary" type="submit">
              Modifier
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ChangePasswordModal;
